import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from './delete-confirm-dialog.component';
import { LoaderService } from '../services/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from '../services/loader.interceptor';
import { LoaderComponent } from './loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { StatusConfirmDialogComponent } from './status-confirm-dialog.component ';
import { PreviewDialogComponent } from './preview-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { CardPreviewComponent } from './card/card.component';
import { QrCodeComponent } from 'ng-qrcode';
import { PageLinksComponent } from './page-links.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { AppHelpInfoComponent } from './app.help.info/app.help.info.component';
import { LogsDisplayComponent } from './logs-display/logs-display.component';
import { LogDataDisplayComponent } from './log-data-display/log-data-display.component';
import { MapViewComponent } from './map-view/map-view.component';
import { PartnerProductComponent } from './partner-product/partner-product.component';
import { PwaInstallerComponent } from './pwa-installer/pwa-installer.component';
import { QrScannerComponentComponent } from '../scaner/qr-scanner-component/qr-scanner-component.component';
// other imports

@NgModule({
  declarations: [
    CardPreviewComponent,
    ConfirmDeleteDialogComponent,
    StatusConfirmDialogComponent,
    PreviewDialogComponent,
    LoaderComponent,
    PageLinksComponent,
    DialogConfirmComponent,
    AppHelpInfoComponent,
    LogsDisplayComponent,
    LogDataDisplayComponent,
    MapViewComponent,
    PartnerProductComponent,
    QrScannerComponentComponent
  ],
  imports: [
    MatProgressSpinnerModule,
    MatButtonModule,
    CommonModule,
    MatDialogModule,
    MatIconModule,
    QrCodeComponent,
  
    // other modules
  ],

  exports: [
    LoaderComponent,
    CommonModule,
    CardPreviewComponent,
    PageLinksComponent,
    DialogConfirmComponent,
    AppHelpInfoComponent,
    LogsDisplayComponent,
    LogDataDisplayComponent,
    MapViewComponent,
    PartnerProductComponent,
    QrScannerComponentComponent
  ]
})
export class  SharedModule { }
